// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton_base__jx0LW","active":"skeleton_active__uFe4B","skeleton":"skeleton_skeleton__KsV45"};